// 카테고리 관련 타입 정의
export interface CategoryOption {
  value: string;
  label: string;
  labelEn?: string; // 영어 라벨 추가
}

// 대분류 카테고리 옵션
export const MAJOR_CATEGORY_OPTIONS: CategoryOption[] = [
  { value: 'AR', label: '예술품', labelEn: 'Art' },
  { value: 'AN', label: '골동품 & 장식예술', labelEn: 'Antiques & Decorative Arts' },
  { value: 'CG', label: '세라믹 & 글라스', labelEn: 'Ceramics & Glass' },
  { value: 'JW', label: '주얼리 & 시계', labelEn: 'Jewelry & Watches' },
  { value: 'FL', label: '패션 & 명품', labelEn: 'Fashion & Luxury' },
  { value: 'CO', label: '수집품', labelEn: 'Collectibles' },
  { value: 'CB', label: '동전, 지폐, 우표', labelEn: 'Coins & Banknotes & Stamps' },
  { value: 'BM', label: '서적 & 필사본', labelEn: 'Books & Manuscripts' },
  { value: 'FU', label: '가구', labelEn: 'Furniture' },
  { value: 'MI', label: '음악 & 악기', labelEn: 'Musical Instruments' },
  { value: 'SP', label: '기타 특수', labelEn: 'Specialty Items' },
  { value: 'AA', label: '아시안 미술 골동품', labelEn: 'Asian Art & Antiques' },
];

// 소분류 카테고리 옵션 (대분류에 따라 변경)
export const MINOR_CATEGORY_OPTIONS: Record<string, CategoryOption[]> = {
  AR: [
    { value: 'PT', label: '회화', labelEn: 'Paintings' },
    { value: 'PM', label: '판화', labelEn: 'Prints' },
    { value: 'DW', label: '드로잉 & 수채화', labelEn: 'Drawings' },
    { value: 'SC', label: '조각', labelEn: 'Sculpture' },
    { value: 'PH', label: '사진', labelEn: 'Photography' },
    { value: 'AA', label: '동양화', labelEn: 'Asian Artworks' },
  ],
  AN: [
    { value: 'EF', label: '유럽 앤틱 가구', labelEn: 'Antique Furniture' },
    { value: 'LI', label: '조명', labelEn: 'Lighting' },
    { value: 'CL', label: '벽시계 & 탁상시계', labelEn: 'Clocks' },
    { value: 'SV', label: '실버웨어', labelEn: 'Silver' },
    { value: 'DA', label: '인형 & 오토마타', labelEn: 'Dolls' },
    { value: 'MP', label: '거울 & 패널', labelEn: 'Mirrors' },
  ],
  CG: [
    { value: 'EP', label: '유럽 도자기', labelEn: 'European Porcelain' },
    { value: 'AC', label: '동양 도자기', labelEn: 'Asian Ceramics' },
    { value: 'AG', label: '아트 글라스', labelEn: 'Art Glass' },
    { value: 'TW', label: '테이블웨어', labelEn: 'Tableware' },
  ],
  JW: [
    { value: 'VJ', label: '빈티지 & 앤틱 주얼리', labelEn: 'Antique Jewelry' },
    { value: 'MJ', label: '현대 디자이너 주얼리', labelEn: 'Modern Jewelry' },
    { value: 'LW', label: '명품 시계', labelEn: 'Luxury Watches' },
    { value: 'AX', label: '장신구 및 액세서리', labelEn: 'Accessories' },
  ],
  FL: [
    { value: 'VC', label: '빈티지 의류', labelEn: 'Vintage Clothing' },
    { value: 'BC', label: '가방 & 클러치', labelEn: 'Bags' },
    { value: 'SA', label: '신발 & 액세서리', labelEn: 'Shoes' },
    { value: 'ST', label: '브랜드 스카프 & 텍스타일', labelEn: 'Scarves' },
    { value: 'LB', label: '럭셔리 브랜드', labelEn: 'Luxury Brand' },
  ],
  CO: [
    { value: 'FT', label: '피규어 & 장난감', labelEn: 'Figures' },
    { value: 'TG', label: '트레이딩 카드 & 게임', labelEn: 'Trading Cards' },
    { value: 'SI', label: '담배용품', labelEn: 'Smoking Items' },
    { value: 'DB', label: '인형 & 테디베어', labelEn: 'Teddy Bears' },
    { value: 'PA', label: '포스터 & 광고물', labelEn: 'Posters' },
  ],
  CB: [
    { value: 'NC', label: '고대 동전', labelEn: 'Ancient Coins' },
    { value: 'WB', label: '세계 지폐', labelEn: 'World Banknotes' },
    { value: 'CC', label: '기념주화', labelEn: 'Commemorative Coins' },
    { value: 'SD', label: '우표 및 초일봉투', labelEn: 'Stamps' },
  ],
  BM: [
    { value: 'OB', label: '고서 및 초판본', labelEn: 'Old Books' },
    { value: 'MA', label: '지도 및 지도책', labelEn: 'Maps' },
    { value: 'SH', label: '사인본 & 수기문서', labelEn: 'Signed Docs' },
    { value: 'AC', label: '예술 관련 도록', labelEn: 'Art Catalogues' },
  ],
  FU: [
    { value: 'CH', label: '의자', labelEn: 'Chairs' },
    { value: 'TB', label: '테이블', labelEn: 'Tables' },
    { value: 'CB', label: '캐비닛', labelEn: 'Cabinets' },
    { value: 'SF', label: '소파', labelEn: 'Sofas' },
    { value: 'RC', label: '러그 & 카펫', labelEn: 'Rugs' },
  ],
  MI: [
    { value: 'SI', label: '현악기', labelEn: 'String Instruments' },
    { value: 'PO', label: '피아노 & 오르간', labelEn: 'Pianos' },
    { value: 'VA', label: '빈티지 오디오', labelEn: 'Vintage Audio' },
    { value: 'LP', label: '고전 음반 & LP', labelEn: 'Classical LP' },
  ],
  SP: [
    { value: 'AM', label: '자동차', labelEn: 'Automobiles' },
    { value: 'DT', label: '인형, 곰 & 장난감', labelEn: 'Dolls & Toys' },
    { value: 'ES', label: '유품 & 보관품', labelEn: 'Estate Storage' },
    { value: 'RE', label: '부동산', labelEn: 'Real Estate' },
  ],
  AA: [
    { value: 'CA', label: '중국 미술 & 골동품', labelEn: 'Chinese Art' },
    { value: 'JA', label: '일본 미술 & 골동품', labelEn: 'Japanese Art' },
    { value: 'KA', label: '한국 미술 & 골동품', labelEn: 'Korean Art' },
    { value: 'IA', label: '인도 & 남아시아 미술 & 골동품', labelEn: 'Indian Art' },
  ],
};

// 대분류 코드로 라벨 찾기
export const getMajorCategoryLabel = (code: string, lang: 'ko' | 'en' = 'ko'): string => {
  const category = MAJOR_CATEGORY_OPTIONS.find(option => option.value === code);
  if (!category) return code;
  return lang === 'en' ? category.labelEn || category.label : category.label;
};

// 소분류 코드로 라벨 찾기
export const getMinorCategoryLabel = (majorCode: string, minorCode: string, lang: 'ko' | 'en' = 'ko'): string => {
  const minorOptions = MINOR_CATEGORY_OPTIONS[majorCode];
  if (!minorOptions) return minorCode;

  const category = minorOptions.find(option => option.value === minorCode);
  if (!category) return minorCode;
  return lang === 'en' ? category.labelEn || category.label : category.label;
};

// 대분류별 소분류 옵션 가져오기
export const getMinorCategoryOptions = (majorCategoryCode: string): CategoryOption[] => {
  return MINOR_CATEGORY_OPTIONS[majorCategoryCode] || [];
};
